import {LOAD_END} from "../types";

const loadingCall= async (dispatch, apiCall) => {
  //dispatch({type: LOAD_START});
  let response = await apiCall();
  dispatch({type: LOAD_END});
  return response;
}
export default loadingCall;